import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "popup-body" }
const _hoisted_2 = { class: "popup-text" }
const _hoisted_3 = { class: "popup-buttons" }

import { useSelectionStore } from '@/pinia/selection'
import { storeToRefs } from 'pinia'
import ButtonOutline from '@/design-system/atoms/buttons/ButtonOutline.vue'
import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'
import { useI18n } from 'vue-i18n'
import { useGeneralStore } from '@/pinia'
import { CoreEntityDto } from '@/interfaces/core.interface'
import { DirectoryItem } from './types'
import { computed, onUnmounted, ref, watch } from 'vue'

type Props = {
  selectedItem?: DirectoryItem
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectionPopup',
  props: {
    selectedItem: { default: undefined }
  },
  emits: ["updateConnection"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const selectionStore = useSelectionStore()
const generalStore = useGeneralStore()
const { currentEntity } = storeToRefs(selectionStore)
const { t } = useI18n()
const emit = __emit
const isNewCurrentEntity = computed(() => hasNewCurrentEntity.value)
const hasNewCurrentEntity = ref(false)

function close() {
  generalStore.setShowNoFeature(false)
  generalStore.setShowConnectionPopup(false)
}
function updateConnection() {
  if (!isNewCurrentEntity.value) return
  generalStore.setShowNoFeature(false)
  generalStore.setShowConnectionPopup(false)
  if (currentEntity.value) {
    emit('updateConnection', currentEntity.value)
  } else {
    console.warn('No current entity selected for connection update.')
  }
}

watch(
  () => currentEntity.value,
  (newVal) => {
    if (!newVal) {
      hasNewCurrentEntity.value = false
      return
    }
    const pathIds = props.selectedItem?.entityConnectionPath ?? []
    const isInPath = pathIds.includes(newVal.id)
    if (!isInPath) {
      hasNewCurrentEntity.value = true
    }
  },
  { immediate: true }
)
onUnmounted(() => {
  hasNewCurrentEntity.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('general__text__file-change-connection-info')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ButtonOutline, {
        class: "button no-height",
        size: "small",
        buttonText: _unref(t)('general__text__cancel'),
        onClick: close
      }, null, 8, ["buttonText"]),
      _createVNode(ButtonPrimary, {
        class: _normalizeClass(["button-primary no-height", { disabled: !isNewCurrentEntity.value }]),
        size: "small",
        disabled: !isNewCurrentEntity.value,
        buttonText: _unref(t)('general__text__file-change-connection'),
        onClick: updateConnection
      }, null, 8, ["class", "disabled", "buttonText"])
    ])
  ]))
}
}

})